import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
}

export const ClockIcon: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    {...rest}
  >
    <g opacity={color ? 1 : 0.4} fill={color}>
      <path d="M14 26C7.096 26 1.5 20.404 1.5 13.5S7.096 1 14 1s12.5 5.596 12.5 12.5S20.904 26 14 26zm0-2.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 26.3c-7.07 0-12.8-5.73-12.8-12.8S6.93.7 14 .7c7.068 0 12.8 5.73 12.8 12.8S21.067 26.3 14 26.3zm0-3.1c5.356 0 9.7-4.343 9.7-9.7 0-5.357-4.344-9.7-9.7-9.7-5.358 0-9.7 4.343-9.7 9.7 0 5.357 4.342 9.7 9.7 9.7zM1.5 13.5C1.5 20.404 7.095 26 14 26c6.903 0 12.5-5.596 12.5-12.5S20.902 1 14 1C7.095 1 1.5 6.596 1.5 13.5zm22.5 0c0 5.523-4.478 10-10 10-5.524 0-10-4.477-10-10s4.476-10 10-10c5.522 0 10 4.477 10 10z"
      />
      <path d="M18.5 13.714h-3.667V9a1 1 0 00-1-1H13.5a1 1 0 00-1 1v5.5A1.5 1.5 0 0014 16h4.5a1 1 0 001-1v-.286a1 1 0 00-1-1z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.233 13.314H18.5a1.4 1.4 0 011.4 1.4V15a1.4 1.4 0 01-1.4 1.4H14a1.9 1.9 0 01-1.9-1.9V9a1.4 1.4 0 011.4-1.4h.333a1.4 1.4 0 011.4 1.4v4.314zm3.267.4a1 1 0 011 1V15a1 1 0 01-1 1H14a1.5 1.5 0 01-1.5-1.5V9a1 1 0 011-1h.333a1 1 0 011 1v4.714H18.5z"
      />
    </g>
  </svg>
)
